import { store } from 'store/store';
import { apiInstanceCached } from '../services/Api';
import { formatShortIsoDate } from '../utilities/format';

/**
 *
 * wait for current package calc, then call other packages
 */
export const calculatePackage = async (params: Map<string, string>, metaArea: MetaArea, coverGroups: CoverGroup[]) => {
	const url = metaArea.items[0].content.quoteApiEndpoint.url;
	const condensedCoverGroups: CoverGroupCalculation[] = [];

	for (const coverage of coverGroups) {
		// only use relevant values
		if (coverage.isActive && coverage.cover_group_id) {
			// don't add duplicate covers
			if (!condensedCoverGroups.some((cover) => cover.cover_group_id === coverage.cover_group_id)) {
				condensedCoverGroups.push({ cover_group_id: coverage.cover_group_id, fields: coverage.fields || [] });
			}
		}
	}

	addCoverageGroupFields(condensedCoverGroups, metaArea);

	const res = await apiInstanceCached().post(
		url,
		spdCalculate(params, metaArea.items[0], condensedCoverGroups)
		// { cache: { interpretHeader: false, methods: ['post'] } }
	);
	if (res.cached) {
		// do delay
		await new Promise((res) => setTimeout(res, 500));
	}
	return res.data;
};

const spdCalculate = (
	params: Map<string, string>,
	metaAreaContent: MetaAreaContent,
	coverGroups: CoverGroupCalculation[]
) => {
	// customer_number: 9691310223,
	// anonymous call ->
	// customer_number: null,
	// ag: 40,

	const customerId = store.getState().customer?.customer_id;
	const party = {
		cpr_number: null,
		customer_number: customerId,
		age: customerId ? undefined : Number.parseInt(store.getState().calculatorForm['CUSTOMER_AGE']?.data?.value),
		legal_information: {
			registered_in_rki: false,
		},
	};

	const fields: QuoteField[] = [];

	params.forEach((value, key) => fields.push({ id: key, value }));

	return {
		party,
		quote: {
			quote_lines: [
				{
					policy_number: null,
					cover_start_date: formatShortIsoDate(), //'2025-12-01',
					payment_frequency: 'MONTHLY',
					general_claim_info: {
						previous_claims: false,
						terminated_earlier: false,
						number_of_customer_years: 1,
						claims_last_3_years: 0,
					},
					product_details: {
						sales_product_name: metaAreaContent.content.salesProduct, // PT
						sales_product_version: metaAreaContent.content.salesProductVersion, //null,
					},
					fields,
					cover_groups: coverGroups,
				},
				// add other product to same calculation. This won't fly online, unless we bundle packages with 1+ products
			],
			tag: {
				business_branch: 'Midtermolen',
				partner_agreement: '47b40e84-f0ce-4a15-8193-1fdeb4240077',
				partner_subagreement: '006e94cc-6d59-4d90-822d-762deaa21c42',
				partner_branch: 'Midtermolen',
			},
		},
	};
};

/* Add fields to cover groups based on meta area mappings. This is needed for covers Selvrisko which needs to be set on fields on the actual coverage
{
    "cover_group_id": "PE_PEL01_PEO01_44",
    "fields": [
        {
            "field_id": "PE_PEL01_PEO01_46_EXCESS_BASE",
            "value": "8003"
        },
        {
            "field_id": "PE_PEL01_PEO01_47_EXCESS_BASE",
            "value": "8003"
        },
        {
            "field_id": "PE_PEL01_PEO01_48_EXCESS_BASE",
            "value": "8003"
        }
    ]
}
*/
const addCoverageGroupFields = (condensedCoverGroups: CoverGroupCalculation[], metaArea: MetaArea) => {
	for (const coverage of condensedCoverGroups) {
		for (const mapping of metaArea.items[0].content.coverageGroupFieldMappings?.items || []) {
			if (coverage.cover_group_id === mapping.content.uniqueIdentifier?.uid) {
				doMapFieldsToCoverage(coverage, mapping.content.coverageGroupFieldMappings);
			}
		}
	}
};

const doMapFieldsToCoverage = (coverage: CoverGroupCalculation, mapping) => {
	for (const coverGroupFieldMapping of mapping?.items || []) {
		const coverageGroupMapping = coverGroupFieldMapping?.content;

		if (coverageGroupMapping) {
			const value = store.getState().calculatorForm[coverageGroupMapping.uidValue?.uid]?.data?.value;

			if (value) {
				(coverage.fields as any).push({ field_id: coverageGroupMapping.uidKey?.uid, value });
			}
		}
	}
};
